import { useEffect } from 'react';
import http from 'utils/http';
import { useAccountLimitReachedModal } from '../../../components/Account/AccountLimitReached';
import { useDemoLimitReachedModal } from '../../../components/Account/DemoLimitReached';

const AccountLimitListener = () => {
  const openLimitReachedModal = useAccountLimitReachedModal();
  const openDemoLimitReachedModal = useDemoLimitReachedModal();

  useEffect(() => {
    const id = http.interceptors.response.use(null, (error) => {
      if (
        error?.response?.status === 403 &&
        error?.response?.data?.error === 'account_limit_exceed'
      ) {
        openLimitReachedModal({ quota: error?.response?.data?.quota });
      }

      if (
        error?.response?.status === 403 &&
        error?.response?.data?.error === 'demo_account_limit_exceed'
      ) {
        openDemoLimitReachedModal();
      }

      throw error;
    });

    return () => http.interceptors.response.eject(id);
  }, []);

  return null;
};

export default AccountLimitListener;
